"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.langSeek = void 0;

var dict_1 = require("./dict");

var langSeek = function langSeek(key, lang) {
  if (dict_1.default[key]) {
    var obj = dict_1.default[key];

    if (obj[lang]) {
      return obj[lang];
    }
  } else return key;
};

exports.langSeek = langSeek;